export default __webpack_public_path__ + "static/architecture-43ed25c6b59581051aa197c3b6d10e53.jpg";